import { footerLinks } from "@/mocks/home";

export default function Footer() {
  return (
    <footer className="mt-10 border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-[1.5fr_1fr_1fr_1fr]">
          {/* 品牌 */}
          <div className="flex flex-col gap-4">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-water-flash-line text-lg"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg font-bold text-foreground-950">吃瓜地址</span>
                <span className="text-[11px] font-medium tracking-wide text-primary-600">永久入口 · 防走丢</span>
              </span>
            </a>
            <p className="max-w-xs text-sm leading-relaxed text-foreground-600">
              吃瓜地址最新发布页，实时同步新网址与永久入口，提供防屏蔽更新提醒，帮你在任何环境下都不走丢、不错过。
            </p>
            <div className="flex items-center gap-2">
              {[
                { icon: "ri-telegram-line", label: "频道" },
                { icon: "ri-qq-line", label: "群" },
                { icon: "ri-rss-line", label: "RSS" },
                { icon: "ri-mail-line", label: "邮件" },
              ].map((s) => (
                <button
                  key={s.label}
                  type="button"
                  title={`订阅更新：${s.label}`}
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-background-200 bg-background-50 text-lg text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
                >
                  <i className={s.icon}></i>
                </button>
              ))}
            </div>
          </div>

          {/* 链接组 */}
          {[
            { title: "关于", items: footerLinks.about },
            { title: "入口", items: footerLinks.guide },
            { title: "支持", items: footerLinks.support },
          ].map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold text-foreground-950">{col.title}</h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {col.items.map((item) => (
                  <li key={item}>
                    <a
                      href="#top"
                      className="inline-flex items-center gap-1.5 text-sm text-foreground-600 transition-colors hover:text-primary-700"
                    >
                      {item}
                      <i className="ri-arrow-right-up-line text-xs opacity-0 transition-opacity group-hover:opacity-100"></i>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-background-200/80 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-foreground-500">
            © 2026 吃瓜地址 · 永久入口与最新网址同步中，谨防假冒，请认准官方标识。
          </p>
          <p className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
            <i className="ri-shield-check-line text-accent-600"></i>
            本页为静态演示，收藏此页即为你的防走丢锚点
          </p>
        </div>
      </div>
    </footer>
  );
}